import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { BIZ, track } from "../data/site";

export const StickyMobileBar = () => (
  <div data-testid="sticky-mobile-bar" className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-white/10 bg-ink/90 backdrop-blur-xl">
    <div className="grid grid-cols-2 gap-3 px-4 py-3">
      <a
        href={BIZ.phoneHref}
        data-testid="sticky-call-now"
        onClick={() => track("click_to_call", { location: "sticky_bar" })}
        className="inline-flex items-center justify-center gap-2 rounded-full border border-accent/50 bg-accent/10 py-3 font-display font-bold text-sm text-accent"
      >
        <Phone size={15} strokeWidth={2.2} />
        Call Now
      </a>
      <Link
        to="/free-estimate"
        data-testid="sticky-free-estimate"
        className="inline-flex items-center justify-center gap-2 rounded-full bg-accentdeep py-3 font-display font-bold text-sm text-white"
      >
        Free Estimate
      </Link>
    </div>
  </div>
);
